<mat-form-field class="w-100 fc"
                appearance="fill"
                *ngIf="filtersResult.length > 0">
  <mat-label>Filtros Selecionados</mat-label>
  <mat-chip-list #chipList
                 aria-label="Filtros Selecionados">
    <mat-chip *ngFor="let filter of filtersResult"
              class="fc__chip"
              [selectable]="selectable"
              [removable]="removable"
              (removed)="remove(filter)">
      {{filter.label}}
      <mat-icon matChipRemove
                color="primary"
                class="fc__remove"
                *ngIf="!filter.disabled">cancel</mat-icon>
    </mat-chip>
  </mat-chip-list>
</mat-form-field>
